import React from 'react';

const SocialCard = ({ platform, username, url, description, iconSvg, color }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="card hover-lift"
      style={{
        display: 'block',
        transition: 'all 0.3s ease',
        borderLeft: `4px solid ${color}`,
        minHeight: '200px'
      }}
    >
      <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem'}}>
        <div 
          className="flex-shrink-0"
          style={{
            width: '3rem',
            height: '3rem', 
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: color,
            color: 'white'
          }}
        >
          <div dangerouslySetInnerHTML={{__html: iconSvg}} />
        </div>
        <div style={{flex: '1', minWidth: '0'}}>
          <h3 style={{fontSize: '1.125rem', fontWeight: 'bold', color: 'var(--forest-800)', marginBottom: '0.5rem'}}>
            {platform}
          </h3>
          <p style={{color: 'var(--forest-600)', fontSize: '0.875rem', marginBottom: '0.5rem'}}>
            @{username}
          </p>
          <p style={{color: 'var(--forest-700)', fontSize: '0.875rem', lineHeight: '1.4'}}>
            {description}
          </p>
        </div>
        <div className="flex-shrink-0">
          <svg style={{width: '1.25rem', height: '1.25rem', color: 'var(--forest-400)'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </div>
      </div>
    </a>
  );
};

const Socials = () => {
  const socialPlatforms = [
    {
      platform: 'Instagram',
      username: 'the_canopy_stream_team',
      url: 'https://instagram.com/the_canopy_stream_team',
      description: 'Behind the scenes content, team photos, and highlights from our streams.',
      color: '#E4405F',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>'
    },
    {
      platform: 'Twitter/X',
      username: 'The_Canopy_Team',
      url: 'https://twitter.com/The_Canopy_Team',
      description: 'Real-time updates, stream announcements, and community interactions.',
      color: '#000000',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>'
    },
    {
      platform: 'Bluesky',
      username: 'thecanopyteam',
      url: 'https://thecanopyteam.bsky.social',
      description: 'Alternative social platform for community updates and discussions.',
      color: '#0085FF',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.015.255-.017.363 0 2.67.296 5.568-.628 6.383-3.364.246-.829.624-5.789.624-6.479 0-.688-.14-1.86-.902-2.203C12.816 1.266 11.811.944 9.175 2.805 6.423 4.747 3.464 8.686 2.377 10.8c-.544 1.058-.409 2.122-.409 2.122s.9.428 1.904-.689c1.003-1.117 2.372-3.081 2.836-3.968l.292-.559z"/></svg>'
    },
    {
      platform: 'YouTube',
      username: 'TheCanopyStreamTeam',
      url: 'https://youtube.com/@TheCanopyStreamTeam',
      description: 'Stream highlights, event recaps, and exclusive team content.',
      color: '#FF0000',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>'
    },
    {
      platform: 'TikTok',
      username: 'thecanopyteam',
      url: 'https://tiktok.com/@thecanopyteam',
      description: 'Short-form content, funny moments, and trending gaming content.',
      color: '#FE2C55',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>'
    },
    {
      platform: 'Discord',
      username: 'thecanopy',
      url: 'https://discord.gg/EpT75sf4CK',
      description: 'Join our community server for real-time chat, gaming sessions, and team updates.',
      color: '#5865F2',
      iconSvg: '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 1.5rem; height: 1.5rem;"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0002 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9554 2.4189-2.1568 2.4189Z"/></svg>'
    }
  ];

  return (
    <div style={{minHeight: '100vh'}}>
      <div className="container" style={{padding: '4rem 1rem'}}>
        {/* Page Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gradient mb-6">
            Follow The Canopy
          </h1>
          <p className="text-lg text-forest-600 max-w-3xl mx-auto">
            Stay connected with The Canopy Stream Team across all our social media platforms. 
            Get the latest updates, behind-the-scenes content, and join our growing community.
          </p>
        </div>

        {/* Social Platform Cards */}
        <div className="grid grid-3 gap-6 mb-16">
          {socialPlatforms.map((social, index) => (
            <SocialCard
              key={social.platform}
              platform={social.platform}
              username={social.username}
              url={social.url}
              description={social.description}
              iconSvg={social.iconSvg}
              color={social.color}
            />
          ))}
        </div>


        {/* Community Guidelines */}
        <div className="mt-16 card">
          <h2 className="text-2xl font-bold text-gradient mb-6 text-center">
            Community Guidelines
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-forest-800 mb-3 flex items-center">
                <span className="text-green-500 mr-2">✅</span>
                What We Love
              </h3>
              <ul className="space-y-2 text-forest-600">
                <li>• Supportive and encouraging interactions</li>
                <li>• Sharing gaming tips and experiences</li>
                <li>• Celebrating team achievements</li>
                <li>• Constructive feedback and suggestions</li>
                <li>• Inclusive and welcoming behavior</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-forest-800 mb-3 flex items-center">
                <span className="text-red-500 mr-2">❌</span>
                What We Don't Allow
              </h3>
              <ul className="space-y-2 text-forest-600">
                <li>• Harassment or bullying of any kind</li>
                <li>• Discriminatory language or behavior</li>
                <li>• Spam or excessive self-promotion</li>
                <li>• Sharing inappropriate content</li>
                <li>• Trolling or disruptive behavior</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Socials;